angular
  .module 'memberPortal'
  .controller 'StylesCtrl', (
    $scope,
    $stateParams,
    DataService,
    styles
  ) ->
    $scope.data = DataService
    domain = $scope.data.domain
    $scope.hash = $stateParams.m
    $scope.styles = styles
